import WarningIcon from '@mui/icons-material/Warning';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';

import CommonDialog, { CommonDialogProps } from './CommonDialog';
import {
  WarningBox,
  InfoBox,
  InfoRow,
  DangerActionButton,
} from './SharedDialogStyles';

export interface PurgeAnnotatorDialogProps extends CommonDialogProps {
  annotatorName: string;
  projectName: string;
  jobCount: number;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function PurgeAnnotatorDialog({
  annotatorName,
  projectName,
  jobCount,
  onConfirm,
  onCancel,
  open,
}: PurgeAnnotatorDialogProps): JSX.Element {
  return (
    <CommonDialog
      onClose={onCancel}
      title="Purge Annotator"
      open={open}
      fullWidth
      maxWidth="sm"
    >
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Are you sure you want to delete all of the selected annotator's
          readings from the project <strong>{projectName}</strong>?
        </Typography>

        <WarningBox>
          <WarningIcon sx={{ color: '#E7000B', fontSize: 24, flexShrink: 0 }} />
          <Box>
            <Typography
              variant="subtitle1"
              fontWeight={600}
              color="#E7000B"
              sx={{ mb: 0.5 }}
            >
              Warning: This action cannot be undone
            </Typography>
            <Typography variant="body2" color="#E7000B">
              All annotation progress and job assignments for this annotator
              will be permanently removed from the system.
            </Typography>
          </Box>
        </WarningBox>

        <InfoBox>
          <InfoRow>
            <Typography variant="body1" color="text.secondary">
              Annotator:
            </Typography>
            <Typography variant="body1" fontWeight={600}>
              {annotatorName}
            </Typography>
          </InfoRow>
          <InfoRow>
            <Typography variant="body1" color="text.secondary">
              Jobs to be removed:
            </Typography>
            <Typography variant="body1" fontWeight={600}>
              {jobCount}
            </Typography>
          </InfoRow>
        </InfoBox>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} variant="outlined" sx={{ px: 3 }}>
          Cancel
        </Button>
        <DangerActionButton
          onClick={onConfirm}
          variant="contained"
          sx={{ px: 3 }}
        >
          Purge Annotator
        </DangerActionButton>
      </DialogActions>
    </CommonDialog>
  );
}
